import React from 'react'
import { Flex } from '@jisr-hr/design-system'
import { useDispatch, useSelector } from 'react-redux'
import { overtimeRequestsCreate } from 'redux/actions/overtimeRequestActions'
import { useRequest } from 'components/global/templates/RequestDrawer/RequestProvider'
import {
  OvertimeDuration,
  Reason,
  Profile,
} from 'components/global/templates/RequestDrawer/components/forms'
import { useForm, useFormState } from 'react-final-form'
import { timeToNumbers } from 'components/global/form/formNormalize'
import JisrLoader from 'components/global/JisrLoader'
import { format, isValid } from 'date-fns'
import { dateWithOutTimeZone } from 'utils/date'

import { useEmployeeAttendanceShifts } from '../../hooks'

const handleValues = (val) => {
  if (val.overtime_type === 'single_day') return val

  let overtime_logs_attributes = []

  val.multiple_shifts?.forEach((record) => {
    const minutes = timeToNumbers(record?.duration)?.totalMinutes

    if (minutes > 0) {
      overtime_logs_attributes = [
        ...overtime_logs_attributes,
        {
          date: record?.date,
          duration: record?.duration,
          ...(record?.detail?.employee_shift_id && {
            employee_shift_id: record?.detail?.employee_shift_id,
          }),
        },
      ]
    }
  })

  return {
    ...val,
    overtime_logs_attributes,
  }
}

const overtimeTypes = {
  single_day: 'single',
  multiple_days: 'multiple',
  bulk_overtime: 'bulk',
}

const OvertimeRequest = () => {
  const dispatch = useDispatch()
  const { change } = useForm()
  const {
    values: { overtime_type },
  } = useFormState()
  const { fetching: fetchingShift } = useEmployeeAttendanceShifts()
  const { setOnSubmit, actionCallback, setInitialValues, vars, drawerToggle } = useRequest()
  const detail = {
    date:
      isValid(dateWithOutTimeZone(vars?.date)) &&
      format(dateWithOutTimeZone(vars?.date), 'yyyy-MM-dd'),
    duration: '00:00',
  }

  const { fetching } = useSelector(({ overtimeRequest }) => overtimeRequest)

  const handleOnSubmit = (values) => {
    const val = handleValues(values)

    dispatch(
      overtimeRequestsCreate(vars.id, {
        input_type: overtimeTypes?.[val.overtime_type],
        reason: val?.reason,
        overtime_logs_attributes: val?.overtime_logs_attributes,
        attachments: val.attachments,
      }),
    ).then(() => {
      drawerToggle()
      if (actionCallback) {
        actionCallback()
      }
    })
  }

  React.useEffect(() => {
    change('overtime_logs_attributes', [overtime_type === 'single_day' ? detail : {}])
  }, [overtime_type])

  React.useEffect(() => {
    setOnSubmit(handleOnSubmit)
    setInitialValues({
      overtime_type: 'single_day',
      overtime_dates: [],
      multiple_shifts: [],
      overtime_logs_attributes: [detail],
    })

    return () => {
      setOnSubmit(() => {})
      setInitialValues({})
    }
  }, [])

  return (
    <Flex
      flexCol
      style={{ gap: '16px' }}
    >
      {(fetching || fetchingShift) && <JisrLoader absolute />}
      <Profile employee={vars?.employee} />
      <OvertimeDuration />
      <Reason />
    </Flex>
  )
}

export default OvertimeRequest
